import { css } from 'styled-components';
/**
 * Returns the aspect ratio of the given width and height as a percentage.
 */
export function aspectRatio(width, height) {
    return (height / width) * 100;
}
/**
 * Re-usable styles for image container where the
 * image needs to maintain it's aspect ratio
 *
 * @param width
 * @param height
 * @returns
 */
export function imageWrapperPreserveRatio(width, height) {
    if (!width && !height) {
        return null;
    }
    return css `
    position: relative;
    overflow: hidden;
    overflow: clip;
    width: 100%;
    aspect-ratio: ${width / height};
  `;
}
/**
 * Calculates the percentage bottom padding
 * required to maintain a certain ratio.
 *
 * To be used in cases where the image ratio
 * changes based on viewport.
 *
 * @param width
 * @param height
 * @returns padding-bottom: {ratioPercentage}%
 */
export function imageWrapperRatioPadding(width, height) {
    if (!width && !height) {
        return '';
    }
    const ratioPercentage = aspectRatio(width, height).toFixed(2);
    return `padding-bottom: ${ratioPercentage}%`;
}
/**
 * Re-usable styles for an image placed within
 * a container maintaining aspect ratio
 */
export const imageCoverContainer = (relative) => css `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  ${!relative && 'position: absolute; top: 0;left: 0;'}
`;
